const Inventory = () => import("./views/inventory.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/inventory",
      component: Inventory,
      name: "Inventory",
      meta: {
        groupName: "Inventory",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
